import { LifeBuoy, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { useLang, STR } from "@/i18n";

const SUPPORT_EMAIL = "duelogames@yahoo.com";

const supportLabels = {
  pt: { toast: `E-mail de suporte copiado: ${SUPPORT_EMAIL}` },
  en: { toast: `Support e-mail copied: ${SUPPORT_EMAIL}` },
  es: { toast: `Correo de soporte copiado: ${SUPPORT_EMAIL}` },
};

export default function Footer() {
  const { lang } = useLang();
  const t = STR[lang];
  const links = [
    { label: t.fl1, href: "/termos" },
    { label: t.fl2, href: "/privacidade" },
    { label: t.fl3, href: "/jogo-responsavel" },
  ];

  const handleSupport = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
    } catch {}
    toast.success((supportLabels[lang] || supportLabels.pt).toast);
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  };

  return (
    <footer data-testid="footer-section" className="relative border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <span className="block w-10 h-10 rounded-xl overflow-hidden border border-amber-400/30">
            <img src="/logo.png" alt="DUELO" className="w-full h-full object-cover" />
          </span>
          <div>
            <p className="font-display font-extrabold tracking-widest text-sm">DUELO</p>
            <p className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              {t.footer_tag}
            </p>
          </div>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-7 gap-y-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-").normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
              className="text-xs text-slate-500 hover:text-amber-300 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleSupport}
            data-testid="footer-support-btn"
            className="flex items-center gap-2 rounded-full bg-amber-300 px-4 py-2 text-[11px] font-black uppercase tracking-[0.12em] text-[#130b25] transition duration-300 hover:-translate-y-0.5 hover:bg-amber-200 active:scale-95"
          >
            <LifeBuoy className="w-3.5 h-3.5" strokeWidth={2.5} />
            {t.fl4}
          </button>
          <div className="flex items-center gap-2 rounded-full border border-amber-400/25 bg-amber-400/5 px-4 py-2">
            <ShieldAlert className="w-3.5 h-3.5 text-amber-300" />
            <span className="mono text-[10px] uppercase tracking-[0.18em] text-amber-300">
              {t.age}
            </span>
          </div>
        </div>
      </div>
      <p className="mt-10 text-center mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
        {t.copy}
      </p>
    </footer>
  );
}